export default __webpack_public_path__ + "static/media/seva-info-assets1.fefa0984.png";